import { app } from '../../../../../app';

app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.user-directories.manage-group.settings', {
        url: '/settings',
        component: 'companyUserDirectoriesManageGroupSettings',
    });
}



// WEBPACK FOOTER //
// ./src/portal/states/company/user-directories/manage-group/settings/group-settings.state.js